module.exports = {
  //api: "http://192.168.0.86",
  //api: "http://192.168.0.46/adminapi",
  //api: "http://127.0.0.1/adminapi",
  api: "https://api2.clomos.es",
    name: "Fresmak",
    publicPath: process.env.NODE_ENV === 'production'
        ? '' // /publicPath
        : ''
}